export default {
  CHANNEL: 'channel',
  YOUTUBE_FEED: 'youtube-feed',
};



// WEBPACK FOOTER //
// ./src/shared/constants/channel-types.js